/**
 * Route Configuration
 * Centralized route constants for the application
 * Used by tours, navigation, and other features that need predictable route paths
 */

export const ROUTES = {
  HOME: '/',
  PROFESSIONS: '/professions',
  PROFESSIONALS: '/professionals',
  PROFESSIONAL_DETAIL: (id: string) => `/professional/${id}`,
  PROFILE: '/profile',
  LOGIN: '/login',
  REGISTER: '/register',
  PASSWORD_RECOVERY: '/passwordrecovery',
} as const

/**
 * Route Patterns
 * Used for route matching in conditions (e.g., useLocation().pathname)
 */
export const ROUTE_PATTERNS = {
  HOME: (path: string) => path === ROUTES.HOME,
  PROFESSIONS: (path: string) => path === ROUTES.PROFESSIONS,
  PROFESSIONALS_LIST: (path: string) => path.startsWith('/professionals/'),
  PROFESSIONAL_DETAIL: (path: string) => path.startsWith('/professional/'),
  PROFILE: (path: string) => path === ROUTES.PROFILE,
  LOGIN: (path: string) => path === ROUTES.LOGIN,
  REGISTER: (path: string) => path === ROUTES.REGISTER,
  PASSWORD_RECOVERY: (path: string) => path === ROUTES.PASSWORD_RECOVERY,
} as const
